import * as React from "react";
import { Box } from "@mui/material";
import { upcomingContractReport } from "state/apis";
import "./index.css";
import { Grid } from "@mui/material";
import moment from "moment";
import DefaultProperty from "components/DefaultProperty";
import { useSelector } from "react-redux";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const UpcomingContractReport = () => {
    const propertyName = useSelector((state) => state.global.propertyName);
    const property = useSelector((state) => state.global.defaultProperty);
    const [isLoading, setIsLoading] = React.useState(false);
    const [data, setData] = React.useState({});
    const [openDefaultProperty, setOpenDefaultProperty] = React.useState(false);
    const currentMonth = moment().format("YYYY-MM");
    const [filter, setFilter] = React.useState({
        monthValue: currentMonth,
    });

    React.useEffect(() => {
        setIsLoading(true);
        if (!property) {
            setOpenDefaultProperty(true);
        }
        fetchData();
        setIsLoading(false);
    }, []);

    React.useEffect(() => {
        setIsLoading(true);
        fetchData();

        setIsLoading(false);
    }, [filter.monthValue]);

    const fetchData = async (id) => {
        try {
            const res = await upcomingContractReport({ monthValue: filter.monthValue });
            setData(res.data);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            setIsLoading(false);
        }
    };

    const handleCloseDefaultProperty = () => {
        setOpenDefaultProperty(false);
    };

    const handleMonth = (date) => {
        if (!date) return;

        setFilter((prevData) => ({
            ...prevData,
            monthValue: date ? date.format("YYYY-MM") : null,
        }));
    };

    const reportRef = React.useRef();

    const handlePrint = () => {
        const input = reportRef.current;

        html2canvas(input, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const margin = 10;
            const imgProps = pdf.getImageProperties(imgData);
            const imgHeight = (imgProps.height * (pdfWidth - 2 * margin)) / imgProps.width;

            let heightLeft = imgHeight;
            let position = margin;

            pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
            heightLeft -= pdfHeight - 2 * margin;

            while (heightLeft > 0) {
                position = heightLeft - imgHeight + margin;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
                heightLeft -= pdfHeight - 2 * margin;
            }

            pdf.save(`${propertyName}-upcoming-contract.pdf`);
        });
    };
    return (
        <Box m="1.5rem 2.5rem" mb={5}>
            <Box display="flex" justifyContent="flex-end" pt={0} paddingLeft={0}>
                <Grid container spacing={1} p={"5px"} alignItems="center">
                    <Grid item xs={2}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label={"Month"}
                                views={["month", "year"]}
                                name="month"
                                onChange={handleMonth}
                                value={filter.monthValue ? dayjs(filter.monthValue) : null}
                                // Set minDate to the first day of the current month
                                minDate={dayjs().startOf("month")}
                                sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused fieldset": {
                                            borderColor: "primary.main",
                                        },
                                    },
                                    "& .MuiInputLabel-root": {
                                        "&.Mui-focused": {
                                            color: "primary.main",
                                        },
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs></Grid>
                    <Grid item xs="auto">
                        <button className="download-btn" onClick={handlePrint}>
                            Download PDF
                        </button>
                    </Grid>
                </Grid>
            </Box>
            {!property && (
                <DefaultProperty
                    open={openDefaultProperty}
                    onClose={() => handleCloseDefaultProperty}
                />
            )}
            <div className="report-container">
                <div ref={reportRef}>
                    <table border="1" cellPadding="5" cellSpacing="0">
                        <thead>
                            <tr>
                                <th colSpan={5} style={{ textAlign: "center" }}>
                                    {propertyName}
                                </th>
                            </tr>

                            <tr>
                                <th style={{ textAlign: "center" }}>PROPERTY NAME</th>
                                <th style={{ textAlign: "center" }}>UNIT</th>
                                <th style={{ textAlign: "center" }}>TENANT NAME</th>
                                <th style={{ textAlign: "center" }}>CONTRACT FROM</th>
                                <th style={{ textAlign: "center" }}>CONTRACT TO</th>
                            </tr>
                        </thead>

                        <tbody>
                            {data && data.length ? (
                                <>
                                    {data.map((val, index) => (
                                        <tr key={index}>
                                            <td>{val?.property?.propertyName}</td>
                                            <td>{val?.unit?.unitNumber}</td>
                                            <td>{val?.tenant?.name}</td>
                                            <td>
                                                {val.contractFrom
                                                    ? moment(val.contractFrom).format("DD/MM/YYYY")
                                                    : ""}
                                            </td>
                                            <td>
                                                {val.contractTo
                                                    ? moment(val.contractTo).format("DD/MM/YYYY")
                                                    : ""}
                                            </td>
                                        </tr>
                                    ))}
                                </>
                            ) : (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: "center" }}>
                                        No data found
                                    </td>
                                </tr>
                            )}

                            <tr>
                                <td colSpan={5}></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </Box>
    );
};

export default UpcomingContractReport;
